import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-home-team',
  templateUrl: './home-team.component.html',
  styleUrls: ['./home-team.component.scss']
})
export class HomeTeamComponent {
  @Input() staffMembers: any[] = [];

  getInitials(name: string): string {
    return name.split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  getAvatarColor(index: number): string {
    const colors = [
      'avatar-blue', 'avatar-purple', 'avatar-pink', 'avatar-green',
      'avatar-orange', 'avatar-teal', 'avatar-red', 'avatar-indigo',
      'avatar-yellow', 'avatar-emerald'
    ];
    return colors[index % colors.length];
  }
}